// src/store/modules/authController.js
import axios from '@/api/axios'
import { MAIN_API } from '@/api/apiUrl'

export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        async getPartnerJobs() {
            const response = await axios.get(`${MAIN_API}/api/partner-category-job/all`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async createJob(_, data) {
            const response = await axios.post(`${MAIN_API}/api/partner-category-job/create`, data, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async deleteJob(_, id) {
            const response = await axios.delete(`${MAIN_API}/api/partner-category-job/delete/` + id, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getJobsHistory() {
            const response = await axios.get(`${MAIN_API}/api/user-car/service-history-jobs/default`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getPartnerCategories() {
            const response = await axios.get(`${MAIN_API}/api/category/partner`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
    },
    getters: {
    }
}
